import { DateTime, DurationInput } from "luxon";

import { formatTimeRangeV2 } from "src/shared/utils/formatTime";
import { THackerAPIDatetime } from "src/shared/utils/hackerapi";
import { timesToOptionsExplicitV2 } from "src/shared/utils/react-select";

export const LIGHTNING_CHALLENGE_RELEASE_TIME = "2026-08-20T05:00:00Z";

const LIGHTNING_CHALLENGE_TIMES: [THackerAPIDatetime, DurationInput][] = [
  [DateTime.utc(2026, 9, 19, 14, 0, 0).toISO(), { minutes: 30 }],
  [DateTime.utc(2026, 9, 19, 14, 30, 0).toISO(), { minutes: 30 }],
  [DateTime.utc(2026, 9, 19, 15, 0, 0).toISO(), { minutes: 30 }],
  [DateTime.utc(2026, 9, 19, 15, 30, 0).toISO(), { minutes: 30 }],
  [DateTime.utc(2026, 9, 19, 16, 0, 0).toISO(), { minutes: 30 }],
  [DateTime.utc(2026, 9, 19, 16, 30, 0).toISO(), { minutes: 30 }],
  [DateTime.utc(2026, 9, 19, 17, 0, 0).toISO(), { minutes: 30 }],
  [DateTime.utc(2026, 9, 19, 17, 30, 0).toISO(), { minutes: 30 }],
  [DateTime.utc(2026, 9, 19, 18, 0, 0).toISO(), { minutes: 30 }],
  [DateTime.utc(2026, 9, 19, 18, 30, 0).toISO(), { minutes: 30 }],
  [DateTime.utc(2026, 9, 19, 19, 0, 0).toISO(), { minutes: 30 }],
];

export const TIME_OPTIONS = [
  ...timesToOptionsExplicitV2(formatTimeRangeV2, LIGHTNING_CHALLENGE_TIMES),
  { label: "", value: "" },
];
